if (!window.r12RevealReady) {
  window.r12RevealReady = true;
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('[data-r12-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    items.forEach(function (item) {
      observer.observe(item);
    });
  });
}
